import { Component } from "react";
import View from "./view";
import { getUser } from "../../backend/storage";
import "./index.css";
import { login } from "../../backend/login";

class LoginScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: "",
      errorMessage: "",
      loggedIn: false,
      loggingIn: false
    };
    this._login = this._login.bind(this);
    this._change = this._change.bind(this);
  }

  async componentDidMount() {
    // let token = await getToken();
    this.setState({ loggedIn: Boolean(await getUser()) });
  }

  render() {
    return View.call(this);
  }

  async _login(event) {
    event.preventDefault();
    const { username, password } = this.state;
    this.setState({ loggingIn: true });
    try {
      await login({ username, password });
      this.setState({ loggingIn: false, loggedIn: true });
    } catch (error) {
      console.error(error);
      this.setState({
        loggingIn: false,
        loggedIn: false
      });
    }
  }

  _change(prop) {
    return event => this.setState({ [prop]: event.target.value });
  }
}

export default LoginScreen;



// WEBPACK FOOTER //
// ./src/screens/login/index.js